<div class="support-page">
  <div class="support-container">

    <!-- Success State -->
    <div class="success-container" *ngIf="submittedTicketId">
      <div class="success-icon-ring">
        <span class="material-symbols-outlined">check_circle</span>
      </div>
      <h2>Ticket Submitted!</h2>
      <p class="success-sub">Your support request has been received. Our team will respond shortly.</p>
      <div class="ticket-id-badge">
        <span class="material-symbols-outlined">confirmation_number</span>
        Ticket ID: <strong>{{ submittedTicketId }}</strong>
      </div>
      <div class="success-actions">
        <button class="btn-primary-action" (click)="goToMyTickets()">
          <span class="material-symbols-outlined">inbox</span>
          View My Tickets
        </button>
        <button class="btn-secondary-action" (click)="resetForm()">
          <span class="material-symbols-outlined">add</span>
          Submit Another
        </button>
      </div>
    </div>

    <!-- Main Support Content -->
    <div *ngIf="!submittedTicketId">
      
      <!-- Page Header -->
<div class="page-header">

  <!-- Mobile Back Button -->
  <button class="btn-page-back" (click)="goBack()" type="button">
    <span class="material-symbols-outlined">arrow_back</span>
  </button>

  <div class="header-left">
    <div class="header-icon">
      <span class="material-symbols-outlined">headset_mic</span>
    </div>
    <div class="header-text">
      <h1>Contact Support</h1>
      <p>We're here to help. Describe your issue and our team will get back to you.</p>
    </div>
  </div>

  <a routerLink="/my-tickets" class="btn-my-tickets">
    <span class="material-symbols-outlined">inbox</span>
    My Tickets
  </a>

</div>

      <!-- Login Warning -->
      <div class="login-warn" *ngIf="!profileId">
        <span class="material-symbols-outlined">warning</span>
        Please <a routerLink="/login">log in</a> to submit a support ticket.
      </div>

      <!-- Two-Column Grid Layout -->
      <div class="support-grid-layout" *ngIf="profileId">
        
        <!-- LEFT PANEL: Quick Help & Sidebar -->
        <div class="sidebar-info-card">
          <div class="sidebar-section">
            <h3 class="sidebar-title">
              <span class="material-symbols-outlined text-[#B01E3E]">help_center</span>
              Quick Help Guide
            </h3>
            
            <div class="faq-item">
              <h4>Payment Status Pending?</h4>
              <p>Transactions automatically clear within 15–30 minutes after verification.</p>
            </div>
            
            <div class="faq-item">
              <h4>Photo ID Rejected?</h4>
              <p>Ensure clear visibility of name, DOB, and photo without glare or cropping.</p>
            </div>
            
            <div class="faq-item">
              <h4>Not Receiving Connects?</h4>
              <p>Review and adjust your partner preference range in settings.</p>
            </div>
          </div>

          <div class="sidebar-divider"></div>

          <div class="sidebar-section">
            <h3 class="sidebar-title">
              <span class="material-symbols-outlined text-[#B01E3E]">contact_support</span>
              Direct Channels
            </h3>
            
            <div class="contact-row">
              <span class="material-symbols-outlined text-gray-500 text-[18px]">mail</span>
              <div>
                <span class="block font-semibold text-gray-800 text-[13px]">Email Support</span>
                <span class="text-gray-500 text-[12px]">support&#64;weddingly.in</span>
              </div>
            </div>

            <div class="contact-row">
              <span class="material-symbols-outlined text-gray-500 text-[18px]">schedule</span>
              <div>
                <span class="block font-semibold text-gray-800 text-[13px]">Helpdesk Hours</span>
                <span class="text-gray-500 text-[12px]">Mon – Sat, 9:00 AM – 7:00 PM</span>
              </div>
            </div>

            <div class="contact-row">
              <span class="material-symbols-outlined text-gray-500 text-[18px]">bolt</span>
              <div>
                <span class="block font-semibold text-gray-800 text-[13px]">Response Time</span>
                <span class="text-gray-500 text-[12px]">Within 2–4 hours</span>
              </div>
            </div>
          </div>

          <div class="sidebar-divider"></div>

          <div class="sidebar-cta">
            <span class="text-[12.5px] text-gray-600">Already submitted a ticket?</span>
            <a routerLink="/my-tickets" class="btn-sidebar-tickets">
              View Existing Tickets
              <span class="material-symbols-outlined text-[15px]">arrow_forward</span>
            </a>
          </div>
        </div>

        <!-- RIGHT PANEL: Support Ticket Form -->
        <div class="form-card">
          
          <!-- Category Selector -->
          <div class="form-group">
            <label class="form-label">
              <span class="material-symbols-outlined label-icon">category</span>
              Category <span class="required">*</span>
            </label>
            <div class="category-grid">
              <button
                *ngFor="let cat of categories"
                class="cat-btn"
                [class.selected]="category === cat.value"
                (click)="category = cat.value"
                type="button">
                <span class="material-symbols-outlined">{{ cat.icon }}</span>
                <span>{{ cat.label }}</span>
              </button>
            </div>
          </div>

          <!-- Subject -->
          <div class="form-group">
            <label class="form-label" for="subject-input">
              <span class="material-symbols-outlined label-icon">title</span>
              Subject <span class="required">*</span>
            </label>
            <input
              id="subject-input"
              type="text"
              class="form-input"
              [(ngModel)]="subject"
              placeholder="Brief description of your issue..."
              maxlength="200">
            <div class="char-count">{{ subject.length }}/200</div>
          </div>

          <!-- Message -->
          <div class="form-group">
            <label class="form-label" for="message-input">
              <span class="material-symbols-outlined label-icon">chat_bubble</span>
              Message <span class="required">*</span>
            </label>
            <textarea
              id="message-input"
              class="form-textarea"
              [(ngModel)]="message"
              placeholder="Please describe your issue in detail. Include any relevant transaction IDs, profile IDs, or error messages..."
              rows="5"></textarea>
          </div>

          <!-- Screenshot Upload -->
          <div class="form-group">
            <label class="form-label">
              <span class="material-symbols-outlined label-icon">attach_file</span>
              Screenshot <span class="optional-tag">Optional</span>
            </label>

            <div class="upload-zone" *ngIf="!screenshotBase64" (click)="fileInput.click()">
              <input #fileInput type="file" accept="image/*" style="display:none" (change)="onFileChange($event)">
              <span class="material-symbols-outlined upload-icon">cloud_upload</span>
              <p>Click to attach a screenshot</p>
              <span class="upload-hint">PNG, JPG, GIF up to 5 MB</span>
            </div>

            <div class="screenshot-preview" *ngIf="screenshotBase64">
              <img [src]="screenshotBase64" alt="Screenshot preview">
              <div class="screenshot-info">
                <span class="material-symbols-outlined text-[#B01E3E]">image</span>
                <span class="file-name">{{ screenshotFileName }}</span>
                <button class="btn-remove-screenshot" (click)="removeScreenshot()" title="Remove">
                  <span class="material-symbols-outlined">close</span>
                </button>
              </div>
            </div>
          </div>

          <!-- Error -->
          <div class="error-alert" *ngIf="errorMsg">
            <span class="material-symbols-outlined">error</span>
            {{ errorMsg }}
          </div>

          <!-- Submit Button -->
          <div class="form-actions">
            <button
              class="btn-submit"
              (click)="submitTicket()"
              [disabled]="submitting || !canSubmit()">
              <span class="material-symbols-outlined" [class.spin]="submitting">
                {{ submitting ? 'progress_activity' : 'send' }}
              </span>
              {{ submitting ? 'Submitting...' : 'Submit Ticket' }}
            </button>
          </div>

        </div>

      </div>

    </div>

  </div>
</div>
